// extracted by mini-css-extract-plugin
export default {"becomeDealerPage":"style_becomeDealerPage__WLpK7","becomeDealerInner":"style_becomeDealerInner__33+uA","loaderBox":"style_loaderBox__Tc0YL","successBox":"style_successBox__Vnb1m"};